import { Conversation } from "@/core/entities/conversation/Conversation";
import { GroupedMessages } from "../utils/ConversationUtils";
import { IUploadAttachmentResponse } from "@/core/repositories/conversation";
import { NewConversationMessagePayload } from "@/core/events/notificationEventsMap";
import { CategoryKey } from "@/core/entities/deduction";
import { ConversationMessage } from "@/core/entities/conversation";

export enum ECurrentMessageReceiveAction {
  INITIAL_LOAD = "INITIAL_LOAD", // when the conversation is loaded for the first time
  LOAD_MORE = "LOAD_MORE", // when the conversation is loaded more messages
  RECEIVE_NEW_MESSAGE = "RECEIVE_NEW_MESSAGE", // when a new message is received
  SEND_MESSAGE = "SEND_MESSAGE", // when a message is sent
}

export type SendMessageOptions = {
  onOptimisticMessage?: (message: ConversationMessage) => void;
};

export type InternalConversationContextType = {
  conversation: Conversation | null;
  groupedMessages: GroupedMessages[];
  currentMessageReceiveAction: ECurrentMessageReceiveAction | null;
  setCurrentMessageReceiveAction: (action: ECurrentMessageReceiveAction | null) => void;
  isInitialLoading: boolean;
  lastReceivedMessage: NewConversationMessagePayload | null;
  isLoadingMore: boolean;
  currentPage: number;
  hasMore: boolean;
  isError: boolean;
  fetchConversation: (referenceId: number, categoryKey: CategoryKey) => Promise<Conversation | null>;
  fetchMessages: () => Promise<ConversationMessage[]>;
  sendMessage: (
    data: any,
    invoiceNumber: string,
    options?: SendMessageOptions
  ) => Promise<{ action: ECurrentMessageReceiveAction; message: ConversationMessage | null }>;
  receiveNewConversationMessage: (payload: NewConversationMessagePayload) => void;
  uploadConversationAttachment: (file: File) => Promise<IUploadAttachmentResponse>;
  resetConversationState: () => void;
};
